import script from "./CommonHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonHeader.vue?vue&type=script&setup=true&lang=js"

import "./CommonHeader.vue?vue&type=style&index=0&id=4b6447b9&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6447b9"]])

export default __exports__